import { constants, Yup } from 'cng-web-lib'
import Namespace from '../../../../constants/locale/Namespace'
import SbciInvoiceKeys from '../../../../constants/locale/key/SbciInvoice'
import OgaCodeMakeValidationSchema from '../lineItem/OgaCodeMakeValidationSchema'
import AddiInfoMakeValidationSchema from '../lineItem/AddiInfoMakeValidationSchema'
import FdaTabMakeValidationSchema from '../lineItem/FdaTabMakeValidationSchema'

const {
  locale: {
    key: { CommonValidationMessageKeys }
  }
} = constants

function makeValidationSchema(translate) {
  const requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  const errMsgMaxLength = translate(
    Namespace.SBCI_INVOICE,
    SbciInvoiceKeys.ValidationMessage.ERROR_MSG_MAX_LENGTH
  )
  const errMsgAlphaNumeric = translate(
    Namespace.SBCI_INVOICE,
    SbciInvoiceKeys.ValidationMessage.ERROR_MSG_ALPHA_NUMERIC
  )
  const errMsgDecimal1 = translate(
    Namespace.SBCI_INVOICE,
    SbciInvoiceKeys.ValidationMessage.ERROR_MSG_DECIMAL1
  )
  const errMsgDecimal2 = translate(
    Namespace.SBCI_INVOICE,
    SbciInvoiceKeys.ValidationMessage.ERROR_MSG_DECIMAL2
  )
  const errMsgDecimal3 = translate(
    Namespace.SBCI_INVOICE,
    SbciInvoiceKeys.ValidationMessage.ERROR_MSG_DECIMAL3
  )

  let regexAlphaNumeric =
    '^[a-zA-Z0-9 ,+\\-$#@%&()!\'`^_:;.?\\[\\]\\{\\}\\/="\\|\\\\ ]*$'

  return Yup.object({
    saveFlag: Yup.boolean().nullable(),
    productId: Yup.string().nullable(),
    partNo: Yup.string()
      .nullable()
      .required(requiredMessage)
      .matches(regexAlphaNumeric, errMsgAlphaNumeric)
      .max(25, errMsgMaxLength + ' 25'),
    htsCode: Yup.string()
      .nullable()
      .required(requiredMessage)
      .matches(regexAlphaNumeric, errMsgAlphaNumeric)
      .max(10, errMsgMaxLength + ' 10'),
    partDesc: Yup.string()
      .nullable()
      .required(requiredMessage)
      .matches(regexAlphaNumeric, errMsgAlphaNumeric)
      .max(50, errMsgMaxLength + ' 50'),
    partType: Yup.string().nullable().required(requiredMessage),
    purchaseOrderNo: Yup.string()
      .nullable()
      .matches(regexAlphaNumeric, errMsgAlphaNumeric)
      .max(20, errMsgMaxLength + ' 20'),
    partRefNo: Yup.string()
      .nullable()
      .matches(regexAlphaNumeric, errMsgAlphaNumeric)
      .max(20, errMsgMaxLength + ' 20'),
    bindRulingIdType: Yup.string().nullable(),
    bindRulingId: Yup.string()
      .nullable()
      .matches(regexAlphaNumeric, errMsgAlphaNumeric)
      .max(21, errMsgMaxLength + ' 21'),
    spclProgInd: Yup.string().nullable(),
    unitValue: Yup.lazy((value) =>
      value === '' || value === null
        ? Yup.string().nullable().required(requiredMessage)
        : Yup.string()
            .nullable()
            .required(requiredMessage)
            .matches(
              /^\d{0,6}(\.\d{0,5})?$/,
              errMsgDecimal1 + ' 6 ' + errMsgDecimal2 + ' 5 ' + errMsgDecimal3
            )
            .max(12, errMsgMaxLength + ' 12')
    ),
    country: Yup.string().nullable().required(requiredMessage),
    qty: Yup.lazy((value) =>
      value === '' || value === null
        ? Yup.string().nullable().required(requiredMessage)
        : Yup.string()
            .nullable()
            .required(requiredMessage)
            .matches(
              /^\d{0,7}(\.\d{0,2})?$/,
              errMsgDecimal1 + ' 7 ' + errMsgDecimal2 + ' 2 ' + errMsgDecimal3
            )
            .max(10, errMsgMaxLength + ' 10')
    ),
    qtyUom: Yup.string().nullable().required(requiredMessage),
    uom1Factor1: Yup.lazy((value) =>
      value === '' || value === null
        ? Yup.string().nullable().required(requiredMessage)
        : Yup.string()
            .nullable()
            .required(requiredMessage)
            .matches(
              /^\d{0,6}(\.\d{0,5})?$/,
              errMsgDecimal1 + ' 6 ' + errMsgDecimal2 + ' 5 ' + errMsgDecimal3
            )
            .max(12, errMsgMaxLength + ' 12')
    ),
    uom2Factor1: Yup.lazy((value) =>
      value === '' || value === null
        ? Yup.string().nullable()
        : Yup.string()
            .nullable()
            .matches(
              /^\d{0,6}(\.\d{0,5})?$/,
              errMsgDecimal1 + ' 6 ' + errMsgDecimal2 + ' 5 ' + errMsgDecimal3
            )
            .max(12, errMsgMaxLength + ' 12')
    ),
    grossWt: Yup.lazy((value) =>
      value === '' || value === null
        ? Yup.string().nullable().required(requiredMessage)
        : Yup.string()
            .required(requiredMessage)
            .matches(
              /^\d{0,7}(\.\d{0,2})?$/,
              errMsgDecimal1 + ' 7 ' + errMsgDecimal2 + ' 2 ' + errMsgDecimal3
            )
            .max(10, errMsgMaxLength + ' 10')
    ),
    netWt: Yup.lazy((value) =>
      value === '' || value === null
        ? Yup.string().nullable()
        : Yup.string()
            .nullable()
            .matches(
              /^\d{0,7}(\.\d{0,2})?$/,
              errMsgDecimal1 + ' 7 ' + errMsgDecimal2 + ' 2 ' + errMsgDecimal3
            )
            .max(10, errMsgMaxLength + ' 10')
    ),
    additionalDescription: Yup.string()
      .nullable()
      .matches(regexAlphaNumeric, errMsgAlphaNumeric)
      .max(60, errMsgMaxLength + ' 60'),
    lineitemOgaCode: Yup.array(
      OgaCodeMakeValidationSchema(translate)
    ).nullable(),
    lineitemAddiInfo: Yup.array(
      AddiInfoMakeValidationSchema(translate)
    ).nullable(),
    hts9802Repair: Yup.object().nullable(),
    usPacking: Yup.object().nullable(),
    goodsreturned: Yup.object().nullable(),
    laceyAct: Yup.array().nullable(),
    fdaTab: Yup.object().nullable(),
    fccTab: Yup.object().nullable(),
    produce: Yup.object().nullable()
  })
}

export default makeValidationSchema
